import { NgModule } from "@angular/core";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { MessageMaster } from "@app/shared/messagemaster/messagemaster.component";
import { MessageService } from "primeng/api";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng";

@NgModule({
	imports: [
		CommonModule,
		ButtonModule,
		MessagesModule,
		MessageModule
	],
	declarations: [
		MessageMaster
	],
	exports: [
		MessageMaster
	],
	providers: [
		MessageService
	]
})
export class MessageMasterModule {}